import { Inclusivity, OrderDirection } from "./PartSearch";
import { StockCheckExtract } from "./Sce";
import { StockSliceCountedLine } from "../store/slices/stockcheckslice";

export interface StockCheckExtractSearch {
  RangeStart: number;
  RangeEnd: number;
  OrderDirection: OrderDirection;
  SearchTerm: string;
  Depot: string;
  Order: StockSearchOrderOption;
}

export enum StockSearchOrderOption {
  UpdatedDate = "UpdatedDate",
  CreatedDate = "CreatedDate",
  StockCheckRef = "StockCheckRef",
}
export enum StockLineSearchOrderOption {
  BinLocation = "BinLocation",
}
export const defaultStockCheckExtractSearch: StockCheckExtractSearch = {
  RangeStart: 0,
  RangeEnd: 10,
  OrderDirection: OrderDirection.Descending,
  SearchTerm: "",
  Depot: "1",
  Order: StockSearchOrderOption.UpdatedDate,
};

export interface StockCheckLinesSearch {
  StockCheckExtract: StockCheckExtract;
  FetchAmount: number;
  LastRecord: string;
  SearchTerm: string;
  FromBin: string;
  ToBin: string;
  SubmittedLineFilter: Inclusivity;
  CountedLineFilter: Inclusivity;
  OrderDirection: OrderDirection;
  Order: StockLineSearchOrderOption;
}

export const defaultStockCheckLinesSearch: StockCheckLinesSearch = {
  StockCheckExtract: {} as StockCheckExtract,
  FetchAmount: 50,
  LastRecord: "",
  SearchTerm: "",
  FromBin: "",
  ToBin: "",
  SubmittedLineFilter: Inclusivity.Shown,
  CountedLineFilter: Inclusivity.Shown,
  OrderDirection: OrderDirection.Ascending,
  Order: StockLineSearchOrderOption.BinLocation,
};

export interface StockCheckSavedDataSearch {
  stockCheckRef: string;
  depotId: string;
  canSeeQoH: boolean;
  countedLines: StockSliceCountedLine[];
}

export default StockCheckExtractSearch;
